import {
    ENDPOINT_URL,
} from '../../constants/commonConstants';
/**
 * HFCL Chat Bot — runtime configuration.
 *
 *   HFCL_USE_OLLAMA
 *     - true  : every user message is sent to the Python/Ollama backend
 *               at HFCL_BACKEND_URL. The backend returns an intent id
 *               which the widget looks up locally to find the route +
 *               postNavAction. If the backend errors or times out, the
 *               chat automatically falls back to the static matcher.
 *     - false : (default) the chat only uses the local static matcher
 *               (token + Damerau-Levenshtein) and the @xenova/transformers
 *               semantic fallback. No network calls.
 *
 *   HFCL_BACKEND_URL
 *     Base URL of the chat-backend service.
 *     Override with REACT_APP_HFCL_CHAT_BACKEND_URL at build time.
 *
 *   HFCL_BACKEND_TIMEOUT_MS
 *     How long to wait for a backend reply before giving up and falling
 *     back to the static matcher.
 */

export const HFCL_USE_OLLAMA = true;

export const HFCL_USE_AGENT =
	typeof process === 'undefined' ||
	process.env?.REACT_APP_HFCL_USE_AGENT !== 'false';

// webpack inlines `process.env.REACT_APP_X` as a build-time string literal,
// so this needs no runtime `process` object - and checking for one here is
// wrong anyway: CRA's browser bundle never defines a global `process`, so a
// `typeof process !== 'undefined'` guard is always false and permanently
// hid whatever these two vars were set to behind their fallback.
//
// Every caller builds URLs as `${HFCL_AGENT_URL}api/agent/...` (no slash of
// its own), so this always needs a trailing slash - ENDPOINT_URL already
// has one, but an env override is free to omit it.
const rawAgentUrl = ENDPOINT_URL;
// const rawAgentUrl = "http://localhost:8009";
export const HFCL_AGENT_URL = rawAgentUrl.endsWith('/') ? rawAgentUrl : `${rawAgentUrl}/`;

export const HFCL_BACKEND_URL =
	process.env.REACT_APP_HFCL_CHAT_BACKEND_URL || 'http://localhost:8001';

export const HFCL_BACKEND_TIMEOUT_MS = 18000;

/**
 * Voice input config (Web Speech API).
 *   HFCL_SPEECH_FALLBACK_LANG : language used when the browser locale
 *                               can't be detected. en-IN handles Indian
 *                               English plus most Hinglish phrases well.
 *   HFCL_SPEECH_AUTO_SEND     : when true, the final transcript is sent
 *                               to the chat immediately; when false the
 *                               text is put in the input box for the user
 *                               to edit before sending.
 *
 * The actual speech language is auto-detected at runtime from
 * navigator.language inside useSpeechRecognition.js. No UI toggle.
 */
export const HFCL_SPEECH_FALLBACK_LANG = 'en-IN';
// Zeplin: stop dictation → transcribe → put text in the input so the user
// can edit / send. Do not auto-submit the transcript.
export const HFCL_SPEECH_AUTO_SEND = false;
